import { postUnauth } from '@/utilities/onwardClient';
import { PRICE_CUSTOMER_UPGRADES } from '@/constants/apiRoutes';

export const priceCustomerUpgrades = (data) => {
    return postUnauth(PRICE_CUSTOMER_UPGRADES, {
        ...data,
    });
};
